import React from "react";

import classNames from "classnames";
import { Link } from "react-router-dom-v5-compat";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  inverted?: boolean;
  danger?: boolean;
  link?: boolean;
  success?: boolean;
  small?: boolean;
  brutalist?: boolean;
  children: React.ReactNode;
  className?: string;
}

export interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  danger?: boolean;
  link?: boolean;
  success?: boolean;
  brutalist?: boolean;
  children?: React.ReactNode;
  className?: string;
}
export const LinkButton = ({
  primary,
  secondary,
  tertiary,
  danger,
  link,
  success,
  children,
  className,
  brutalist,
  to,
  ...props
}: LinkButtonProps) => (
  <Link
    className={classNames(className, "btn no-underline", {
      primary:
        primary || !(primary || secondary || tertiary || link || success),
      secondary,
      tertiary,
      link,
      brutalist,
      danger,
      success,
    })}
    to={to}
    {...props}
  >
    {children}
  </Link>
);

export const Button = ({
  primary,
  secondary,
  tertiary,
  small,
  link,
  danger,
  brutalist,
  success,
  inverted,
  children,
  className,
  ...props
}: ButtonProps) => (
  <button
    className={classNames(className, "btn", {
      primary:
        primary || !(primary || secondary || tertiary || link || success),
      brutalist,
      secondary,
      small,
      inverted,
      tertiary,
      link,
      danger,
      success,
    })}
    {...props}
  >
    {children}
  </button>
);

export default Button;
